import styled, { keyframes } from "styled-components";

import { ANIMATION } from "../../../utils/constants";

// Animations
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

const slide = keyframes`
  from { transform: translateX(-100%); }
  to { transform: translateX(400%); }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0%;
  animation: ${fadeIn} ${ANIMATION.duration.moderate}
    ${ANIMATION.easing.easeOut};
`;

// Thin indeterminate bar shown while a filter change refetches in place, so the
// page reads as working rather than frozen. Pinned to the top of the content.
export const ProgressTrack = styled.div`
  position: sticky;
  top: 0;
  z-index: 2;
  height: 2px;
  overflow: hidden;
`;

export const ProgressBar = styled.div`
  width: 25%;
  height: 100%;
  background: var(--color-primary);
  animation: ${slide} 1.1s ${ANIMATION.easing.easeOut} infinite;

  @media (prefers-reduced-motion: reduce) {
    width: 100%;
    animation: none;
    opacity: 0.7;
  }
`;
